import { Routes } from '@angular/router';

import { LoginComponent } from '../../auth/components/login/login.component';
import { PublicDefaultMenuComponent } from '../../layout/components/public-layout/public-default-menu/public-default-menu.component';
import { PasswordForgotComponent } from '../../auth/components/password/password-forgot/password-forgot.component';
import { PasswordResetComponent } from '../../auth/components/password/password-reset/password-reset.component';
import { RegistrationComponent } from '../../auth/components/registration/registration.component';
import { NotFoundComponent } from '../components/not-found/not-found.component';
import { OauthLoginComponent } from '../../auth/components/login/oauth-login/oauth-login.component';
import { Saml2LoginComponent } from '../../auth/components/login/saml2-login/saml2-login.component';
import { LegalNoticePageComponent } from '../../legal-notice/components/legal-notice-page/legal-notice-page.component';
import { LtiLoginComponent } from '../../auth/components/login/lti-login/lti-login.component';

import { DefaultThemeResolver } from '../../layout/resolvers/default-theme.resolver';
import { CustomThemeResolver } from '../../layout/resolvers/custom-theme.resolver';

import { SsoProviderGuard } from '../../auth/guards/sso-provider.guard';
import { AuthMethodIsAllowedGuard } from '../../auth/guards/auth-method-is-allowed.guard';
import { RegistrationGuard } from '../../auth/guards/registration.guard';

export const PUBLIC_ROUTES: Routes = [
  {
    path: '',
    resolve: [
      DefaultThemeResolver,
      CustomThemeResolver,
    ],
    data: {
      customTheme: true,
    },
    children: [
      {
        path: '',
        component: PublicDefaultMenuComponent,
        outlet: 'publicHeaderMenu',
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        data: {
          section: 'section-auth',
        },
        children: [
          {
            path: '',
            component: LoginComponent,
            data: {
              page: 'login',
            },
          },
          {
            path: 'oauth2/:idp',
            canActivate: [SsoProviderGuard, AuthMethodIsAllowedGuard],
            component: OauthLoginComponent,
            data: {
              page: 'login/sso',
            },
          },
          {
            path: 'saml2/:idp',
            canActivate: [SsoProviderGuard, AuthMethodIsAllowedGuard],
            component: Saml2LoginComponent,
            data: {
              page: 'login/sso',
            },
          },
          {
            path: 'lti/launch',
            // canActivate: [SsoProviderGuard, AuthMethodIsAllowedGuard],
            component: LtiLoginComponent,
            data: {
              page: 'login/lti',
            },
          },
        ],
      },
      {
        path: 'password/forgot',
        component: PasswordForgotComponent,
        canActivate: [AuthMethodIsAllowedGuard],
        data: {
          path: 'password/forgot',
        },
      },
      {
        path: 'password/reset/:hash/:token',
        canActivate: [AuthMethodIsAllowedGuard],
        component: PasswordResetComponent,
      },
      {
        path: 'registration/:code',
        canActivate: [AuthMethodIsAllowedGuard, RegistrationGuard],
        component: RegistrationComponent,
        data: {
          path: 'registration',
        },
      },
      {
        path: 'contact',
        loadChildren: () => import('./../../contact/contact.module').then(m => m.ContactModule),
        data: {
          section: 'section-contact',
        },
      },
      {
        path: 'legal-notice/:category',
        component: LegalNoticePageComponent,
        data: {
          page: '/legal-notice',
          section: 'section-faq',
        },
      },
      {
        path: '404',
        component: NotFoundComponent,
      },
    ],
  },
];
